import { Button, Result, Typography } from "antd";
import { useNavigate } from "react-router-dom";

export default function PessoaBloqueioScreen() {
    const navigate = useNavigate();

    return <Result
        status="403"
        title="Olá! Há algo errado com a sua conta!"
        subTitle={<>
            <Typography.Paragraph>Por favor, entre em contato com a Quiron e vamos te ajudar.</Typography.Paragraph>
            <Typography.Paragraph>
                E-mail: <Typography.Link target="_blank" href="mailto:tatiane@quironturismo.com.br?subject=Problema%20com%20a%20minha%20conta" copyable={{ text: 'tatiane@quironturismo.com.br' }}>tatiane@quironturismo.com.br</Typography.Link>
            </Typography.Paragraph>
            <Typography.Paragraph>
                Whatsapp: <Typography.Link target="_blank" href="https://wa.me/5511917211992?text=Problema%20com%20a%20minha%20conta" copyable={{ text: '(11) 91721-1992' }}>(11) 91721-1992</Typography.Link>
            </Typography.Paragraph>
                
        </>}
        extra={<Button type="primary" onClick={() => navigate('/viagens')}>Voltar para Minhas Viagens</Button>}
    />
}